import { Base, ReverCard } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import InfoIcon from '@/assets/images/icons/InfoIcon.svg'

export const InstructionsBanner = () => {
  const { t } = useTranslation()

  return (
    <ReverCard fullWidth>
      <div className="font-roobert">
        <div className="flex w-full items-center gap-2 rounded-t-md bg-blue-100 p-3">
          <img src={InfoIcon} className="size-5" />
          <p className="text-sm font-medium text-neutral-900">
            {t('edit_reasons.banner_title')}
          </p>
        </div>

        <div className="flex flex-col gap-4 p-4">
          <ul className="flex list-disc flex-col gap-1 pl-4 text-sm text-neutral-600">
            <li>{t('edit_reasons.rule_1')}</li>
            <li>{t('edit_reasons.rule_2')}</li>
          </ul>

          <div>
            <p className="text-xs font-medium uppercase tracking-wide text-neutral-500">
              {t('edit_reasons.rule_3')}
            </p>
            <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,20rem)] items-center gap-x-8 py-3">
              <div>
                <p className="text-sm">{t('edit_reasons.example3_title')}</p>
                <p className="text-xs text-neutral-500">
                  {t('edit_reasons.example3_description')}
                </p>
              </div>
              <Base.Switch checked readOnly tabIndex={-1} aria-hidden />
              <Base.TagInput
                values={['T-shirts', 'Shoes']}
                onChange={() => undefined}
                readOnly
                removeLabel={(value) => t('tag_input.remove', { value })}
              />
            </div>
          </div>
        </div>
      </div>
    </ReverCard>
  )
}
